import { AceEditor } from 'modules/aceEditor';
import { useController } from 'react-hook-form';
import { SETTINGS_DISPLAY_CONTENT } from 'modules/templateEditor/common/constants';
import { Delete } from 'ui/icons';
import { GhostButton } from 'ui/button';
import { pxToRem } from 'utils/convert';
import { RawDataContainer } from './styles';

export const DEFAULT_RAW_JSON = '{}';
const EDITOR_HEIGHT = pxToRem(230);

export const RawDataInput = () => {
  const {
    field: { onChange: setPayload, value: payload },
  } = useController({
    name: 'payload',
  });

  const formatJson = (json: string) => {
    if (json.length === 0) return setPayload(DEFAULT_RAW_JSON);

    try {
      setPayload(JSON.stringify(JSON.parse(json), null, 2));
    } catch (error) {
      console.warn(`Error in raw data input ${error}`); // eslint-disable-line no-console
    }
  };

  return (
    <RawDataContainer data-test="raw-data">
      <AceEditor
        editorProps={{ $blockScrolling: Infinity }}
        height={EDITOR_HEIGHT}
        mode="json"
        onBlur={() => formatJson(payload)}
        onChange={(json) => setPayload(json)}
        value={payload ?? DEFAULT_RAW_JSON}
        wrapEnabled
      />
      <GhostButton data-test="raw-data-delete-button" onClick={() => setPayload('{}')}>
        <Delete />
        {SETTINGS_DISPLAY_CONTENT.removeRawButton}
      </GhostButton>
    </RawDataContainer>
  );
};
